import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { DowntimeInputSelect } from "./priority/DowntimeInputSelect";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const DowntimeInputItem = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("priority");

  if (config && (config?.hidden || config?.downtime?.length === 0))
    return <></>;

  const label = t("maintenance:ticket.create.priority.downtime.label");
  return (
    <Form.Item<SaveTicketValues> name="downtime" label={label} {...props}>
      {props.type === "dropdown" ? <DowntimeInputSelect /> : null}
    </Form.Item>
  );
});
